import React from "react";
import {
  Trash2, Edit2, X, Check, UserPlus, AlertTriangle, RefreshCw
} from "lucide-react";

export const AddAdminModal = ({ show, onClose, form, setForm, roles, onSubmit }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6" onClick={e => e.stopPropagation()} data-testid="rbac-add-modal">
        <h3 className="text-lg font-bold text-[#1E1B4B] mb-4 flex items-center gap-2"><UserPlus size={18} /> Add Admin Panel Member</h3>
        <div className="space-y-3">
          <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} placeholder="Username (e.g. john@doozygo)" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-[#E83E8C] outline-none" data-testid="rbac-add-username" />
          <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Full Name" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-[#E83E8C] outline-none" />
          <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Password (min 6 chars)" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-[#E83E8C] outline-none" data-testid="rbac-add-password" />
          <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-[#E83E8C] outline-none" data-testid="rbac-add-role">
            {Object.entries(roles).map(([key, val]) => (
              <option key={key} value={key}>{val.label} (Level {val.level})</option>
            ))}
          </select>
          <input value={form.department} onChange={e => setForm({ ...form, department: e.target.value })} placeholder="Department (optional)" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-[#E83E8C] outline-none" />
        </div>
        <div className="flex gap-2 mt-5">
          <button onClick={onClose} className="flex-1 py-2.5 rounded-lg border border-gray-200 text-sm font-medium text-[#475569]">Cancel</button>
          <button onClick={onSubmit} className="flex-1 py-2.5 rounded-lg bg-[#E83E8C] text-white text-sm font-bold hover:bg-[#d62f7a]" data-testid="rbac-add-submit">Add Member</button>
        </div>
      </div>
    </div>
  );
};

export const AddOpsModal = ({ show, onClose, form, setForm, onSubmit }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-bold text-[#1E1B4B] mb-4 flex items-center gap-2"><UserPlus size={18} className="text-[#FF9F1C]" /> Add Ops Team Member</h3>
        <div className="space-y-3">
          <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Full Name" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm" />
          <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value.replace(/\D/g, "").slice(0, 10) })} placeholder="Phone (10 digits)" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm font-mono" />
          <input value={form.pin} onChange={e => setForm({ ...form, pin: e.target.value.replace(/\D/g, "").slice(0, 4) })} placeholder="4-digit PIN" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm font-mono" />
          <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })} className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm">
            <option value="decorator">Decorator (Decor Expert)</option>
            <option value="ops_manager">Ops Manager</option>
          </select>
        </div>
        <div className="flex gap-2 mt-5">
          <button onClick={onClose} className="flex-1 py-2.5 rounded-lg border border-gray-200 text-sm font-medium text-[#475569]">Cancel</button>
          <button onClick={onSubmit} className="flex-1 py-2.5 rounded-lg bg-[#FF9F1C] text-white text-sm font-bold hover:bg-[#e88f18]">Add Member</button>
        </div>
      </div>
    </div>
  );
};

export const EditMemberModal = ({ member, setMember, roles, onSubmit }) => {
  if (!member) return null;
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setMember(null)}>
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6" onClick={e => e.stopPropagation()} data-testid="rbac-edit-modal">
        <h3 className="text-lg font-bold text-[#1E1B4B] mb-4 flex items-center gap-2"><Edit2 size={18} /> Edit: {member.username}</h3>
        <div className="space-y-3">
          <div>
            <label className="text-xs text-[#94a3b8] mb-1 block">Name</label>
            <input value={member.name} onChange={e => setMember({ ...member, name: e.target.value })} className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm" />
          </div>
          <div>
            <label className="text-xs text-[#94a3b8] mb-1 block">Role</label>
            <select value={member.role} onChange={e => setMember({ ...member, role: e.target.value })} className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm" data-testid="rbac-edit-role">
              {Object.entries(roles).map(([key, val]) => (
                <option key={key} value={key}>{val.label} (Level {val.level})</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-xs text-[#94a3b8] mb-1 block">Department</label>
            <input value={member.department || ""} onChange={e => setMember({ ...member, department: e.target.value })} className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm" />
          </div>
          <div>
            <label className="text-xs text-[#94a3b8] mb-1 block">New Password (leave blank to keep current)</label>
            <input type="password" value={member.newPassword || ""} onChange={e => setMember({ ...member, newPassword: e.target.value })} placeholder="New password" className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm" />
          </div>
          <div>
            <label className="text-xs text-[#94a3b8] mb-1 block">Access after role change</label>
            <div className="flex flex-wrap gap-1 p-2 bg-gray-50 rounded-lg">
              {(roles[member.role]?.tabs || []).map(t => (
                <span key={t} className="px-2 py-0.5 bg-[#E83E8C]/10 text-[#E83E8C] rounded text-[10px] font-medium">{t}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="flex gap-2 mt-5">
          <button onClick={() => setMember(null)} className="flex-1 py-2.5 rounded-lg border border-gray-200 text-sm font-medium text-[#475569]">Cancel</button>
          <button onClick={onSubmit} className="flex-1 py-2.5 rounded-lg bg-blue-500 text-white text-sm font-bold hover:bg-blue-600 flex items-center justify-center gap-1" data-testid="rbac-edit-save">
            <Check size={14} /> Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export const ClearConfirmModal = ({ show, onClose, selectedCollections, clearing, onConfirm }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 text-center" onClick={e => e.stopPropagation()} data-testid="clear-confirm-modal">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertTriangle size={28} className="text-red-500" />
        </div>
        <h3 className="text-lg font-bold text-[#1E1B4B] mb-2">Confirm Data Deletion</h3>
        <p className="text-sm text-[#475569] mb-3">You are about to permanently delete data from:</p>
        <div className="bg-red-50 rounded-lg p-3 mb-4 max-h-32 overflow-y-auto">
          {Array.from(selectedCollections).map(c => (
            <span key={c} className="inline-block px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs font-medium m-0.5">{c}</span>
          ))}
        </div>
        <p className="text-xs text-red-500 font-medium mb-4">This action cannot be undone!</p>
        <div className="flex gap-2">
          <button onClick={onClose} className="flex-1 py-2.5 rounded-lg border border-gray-200 text-sm font-medium text-[#475569]">Cancel</button>
          <button onClick={onConfirm} disabled={clearing} className="flex-1 py-2.5 rounded-lg bg-red-500 text-white text-sm font-bold hover:bg-red-600 disabled:opacity-50 flex items-center justify-center gap-1" data-testid="clear-confirm-btn">
            {clearing ? <><RefreshCw size={14} className="animate-spin" /> Clearing...</> : <><Trash2 size={14} /> Delete Permanently</>}
          </button>
        </div>
      </div>
    </div>
  );
};
